import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import { browserHistory } from 'react-router';
// Components
import Item from '../../layout/sui/item/Item';
import CloseButton from '../../layout/closeButton/CloseButton';


const propTypes = {
  roundTableDetails: PropTypes.object,
};

const RoundTableDetails = (props) => {
  const roundTableDetails = props.roundTableDetails;
  const { day, start, end, room } = roundTableDetails;
  const calcTime = (time) => {
    return new Date(`${day}, ${time}`);
  };

  const date = new Date(day);
  const starting = calcTime(start);
  const ending = calcTime(end);

  const itsDate = (
    <FormattedMessage
      id="roundTableDetailsDateTime"
      description="Panel date and time"
      defaultMessage="To be confirmed"
      values={{
        icon: <i className="calendar icon" />,
        date,
        starting,
        ending,
      }}
    />
  );

  const itsRoom = (
    <FormattedMessage
      id="roundTableDetailsRoom"
      description="Panel room"
      defaultMessage="{icon} Room {room}"
      values={{
        icon: <i className="unmute icon" />,
        room: <strong>{room}</strong>,
      }}
    />
  );

  const coordinator = roundTableDetails.coordinator;
  const coordinatorImage = coordinator && coordinator.image
  ? `http://palestra.futurecom.com.br/uploads/pessoas/${coordinator.image}`
  : 'http://agenda.futurecom.com.br/images/default-user.png';

  const participants = roundTableDetails.participants && roundTableDetails.participants.map((participant, i) => {
    const image = participant.image
    ? `http://palestra.futurecom.com.br/uploads/pessoas/${participant.image}`
    : 'http://agenda.futurecom.com.br/images/default-user.png';

    return (
      <Item
        key={i}
        image={image}
        alt={participant.name}
        size="tiny"
        header={participant.name}
        meta={
          <div className="ui basic label">
            {participant.company} <div className="detail">{participant.job}</div>
          </div>
        }
        description={participant.resume}
      />
    );
  });

  const handleClose = () => {
    browserHistory.goBack();
  };

  return (
    <ModalContainer onClose={handleClose}>
      <ModalDialog onClose={handleClose}>
        <div className="ui text container">
          <div className="ui top attached segment">
            <h3 className="ui dividing header">{roundTableDetails.title}</h3>
            <div className="ui label">{itsDate}</div>
            <div className="ui label">{itsRoom}</div>
            <div className="ui hidden divider" />
            <p>{roundTableDetails.resume}</p>
          </div>
          {
            coordinator &&
              <div className="ui middle attached segment">
                <h4 className="ui header">
                  {
                    <FormattedMessage
                      id="coordinator"
                      description="Coordinator"
                      values={{ gender: coordinator.gender }}
                    />
                  }
                </h4>
                <div className="ui items">
                  <Item
                    image={coordinatorImage}
                    alt={coordinator.name}
                    size="tiny"
                    header={coordinator.name}
                    meta={
                      <div className="ui basic label">
                        {coordinator.company} <div className="detail">{coordinator.job}</div>
                      </div>
                    }
                    description={coordinator.resume}
                  />
                </div>
              </div>
          }
          <div className="ui bottom attached segment">
            <h4 className="ui header">
              {
                <FormattedMessage
                  id="invitedPanelists"
                  description="Invited panelists"
                />
              }
            </h4>
            <div className="ui divided items">
              {participants && participants}
            </div>
          </div>
          <div className="ui hidden divider" />
          <CloseButton handleClose={handleClose} />
        </div>
      </ModalDialog>
    </ModalContainer>
  );
};

RoundTableDetails.propTypes = propTypes;

export default RoundTableDetails;



/** WEBPACK FOOTER **
 ** ./src/components/screens/roundTables/RoundTableDetails.js
 **/